import { render, staticRenderFns } from "./ReceivePrintDetails_Total.vue?vue&type=template&id=76076396&"
import script from "./ReceivePrintDetails_Total.vue?vue&type=script&lang=js&"
export * from "./ReceivePrintDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports